import React, { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { StyledTextarea } from './Textarea.styles';
import { InputSize } from '../inputSizes';

type TextAreaProps = ComponentPropsWithoutRef<'textarea'> & {
  hasError?: boolean;
  size?: InputSize;
};

export const Textarea = forwardRef<ElementRef<'textarea'>, TextAreaProps>(function Textarea(
  { hasError, ...rest },
  ref
) {
  return <StyledTextarea {...rest} hasError={hasError} ref={ref} />;
});
